import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Paper } from "@mui/material";
import { ENTITY_LABELS } from "./utils/labelMapping";

export default function BrandTable({ name, data = [] }) {
  return (
    <TableContainer component={Paper}>
      <h5 className="my-3">{name}</h5>
      <Table  aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="right">LLM</TableCell>
            <TableCell align="right">{ENTITY_LABELS.rank}</TableCell>
            <TableCell align="right">favorability</TableCell>
            <TableCell align="right">Score</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.llm}
              </TableCell>
              <TableCell align="right">{row.rank}</TableCell>
              <TableCell align="right">{row.favorability}</TableCell>
              <TableCell align="right">{row.score}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
